class NotificationBar extends HTMLElement {

  constructor() {
    super();
    this.countdownSettings = JSON.parse(this.dataset.countdown);
    this.countdownInterval = null;

    // Check if start time is provided and if the current time is before the start time
    if (this.countdownSettings.start_year && this.countdownSettings.start_month && this.countdownSettings.start_day) {
      const now = new Date();
      const startTime = new Date(
        this.countdownSettings.start_year,
        this.countdownSettings.start_month - 1, // Month is 0-indexed
        this.countdownSettings.start_day,
        this.countdownSettings.start_hour || 0,
        this.countdownSettings.start_minute || 0,
      ).getTime();

      if (now.getTime() < startTime) {
        this.removeBar();
        return;
      }
    }

    if (this.countdownSettings.enabled) {
      this.startCountdown();
    }

    !this.closest('swiper-slider').swiperInstance.initialized && this.closest('swiper-slider').swiperInstance.init();
  }

  startCountdown() {
    if (!this) return;

    const daysElement = this.querySelector('.notification-bar__timer-item--days')?.querySelector('.notification-bar__timer-time');
    const hoursElement = this.querySelector('.notification-bar__timer-item--hours')?.querySelector('.notification-bar__timer-time');
    const minutesElement = this.querySelector('.notification-bar__timer-item--minutes')?.querySelector('.notification-bar__timer-time');
    const secondsElement = this.querySelector('.notification-bar__timer-item--seconds')?.querySelector('.notification-bar__timer-time');

    const nowTime = new Date();

    const originalEndTime = new Date(
      this.countdownSettings.end_year,
      this.countdownSettings.end_month - 1, // Month is 0-indexed
      this.countdownSettings.end_day,
      this.countdownSettings.end_hour,
      this.countdownSettings.end_minute,
    ).getTime();

    const endOfDayTime = new Date(
      nowTime.getFullYear(),
      nowTime.getMonth(),
      nowTime.getDate(),
      23,
      59,
      59,
    ).getTime();

    let endTime;

    const isLooping = this.countdownSettings.loop === true || this.countdownSettings.loop === 'true';

    if (isLooping) {
      endTime = Math.min(originalEndTime, endOfDayTime);
    }
    else {
      endTime = originalEndTime;
    }

    this.countdownInterval = setInterval(() => {
      const now = new Date().getTime();
      const distance = endTime - now;

      if (distance < 0) {
        clearInterval(this.countdownInterval);
        this.removeBar();
        return;
      }

      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      daysElement.textContent = this.formatNumber(days);
      hoursElement.textContent = this.formatNumber(hours);
      minutesElement.textContent = this.formatNumber(minutes);
      secondsElement.textContent = this.formatNumber(seconds);
    }, 1000);
  }

  formatNumber(number) {
    return number < 10 ? `0${number}` : number.toString();
  }

  removeBar() {
    this.remove();
  }
}

customElements.define('notification-bar', NotificationBar);
